<script>

  import { gtmSendEvent } from '@/utils/gtm-send-event'

  import Hamburger from '@/components/Hamburger'
  import CartMenuItem from '@/components/Ecommerce/Cart/CartMenuItem.vue'
  import DesktopNavigation from '@/components/DesktopNavigation'

  export default {
    components: {
      Hamburger,
      CartMenuItem,
      DesktopNavigation
    },
    setup (props, { root }) {
      const trackEvent = () => {
        gtmSendEvent('header-desktop', 'mijn-examenbundel', 'clicked')
      }

      return {
        trackEvent
      }
    }
  }
</script>

<template>
  <div class="container px-4 lg:px-8">
    <div class="flex items-center justify-between lg:items-start">
      <div class="flex gap-x-3">
        <nuxt-link
          to="/"
          aria-label="Examenbundel"
        >
          <q-svg name="examenbundel-logo" />
        </nuxt-link>
      </div>
      <desktop-navigation class="hidden lg:block" />
      <div class="flex space-x-3 md:space-x-4">
        <div class="flex space-x-3 md:space-x-4">
          <e-button
            tag="nuxt-link"
            to="/zoeken"
            aria-label="Zoeken"
            type="secondary"
          >
            <q-icon name="search" />
          </e-button>
          <CartMenuItem class="cart-button" />
        </div>
        <e-button
          tag="nuxt-link"
          to="/mijnexamenbundel"
          aria-label="Mijn Examenbundel"
          type="primary"
          @click.native="trackEvent()"
        >
          <q-icon name="profile" />
          <span class="hidden ml-2 xl:block">
            Mijn Examenbundel
          </span>
        </e-button>
        <hamburger class="lg:hidden" />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
header {
  .button-secondary {
    @apply p-1.5 md:p-3 border-gray-200 border rounded-lg;
    @apply shadow-none;


    @screen md {
    box-shadow: inset 0 0 0 0.125rem theme("colors.gray.200");
    }
  }
  .button-primary {
    @apply p-1.5 md:p-3;
  }
}
</style>
